
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"calendar (7)","xmlns":"http://www.w3.org/2000/svg","width":"17.974","height":"17.974","viewBox":"0 0 17.974 17.974"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 29580","d":"M14.5 1.381h-.67V.702a.7.7 0 10-1.4 0v.679H5.544V.702a.7.7 0 10-1.4 0v.679H3.47A3.475 3.475 0 000 4.852v9.65a3.475 3.475 0 003.47 3.472H14.5a3.475 3.475 0 003.47-3.472v-9.65a3.475 3.475 0 00-3.47-3.471zM3.47 2.786h.67v1.368a.7.7 0 101.4 0V2.786h6.89v1.368a.7.7 0 101.4 0V2.786h.67a2.069 2.069 0 012.067 2.067v.671H1.4v-.672a2.069 2.069 0 012.07-2.066zM14.5 16.57H3.47a2.069 2.069 0 01-2.07-2.068V6.927h15.171v7.575A2.069 2.069 0 0114.5 16.57zM6.234 9.686a.7.7 0 01-.7.7H4.152a.7.7 0 010-1.4h1.38a.7.7 0 01.702.7zm8.289 0a.7.7 0 01-.7.7h-1.38a.7.7 0 010-1.4h1.38a.7.7 0 01.701.7zm-4.149 0a.7.7 0 01-.7.7H8.293a.7.7 0 010-1.4h1.38a.7.7 0 01.702.7zm-4.14 4.145a.7.7 0 01-.7.7H4.152a.7.7 0 010-1.4h1.38a.7.7 0 01.702.7zm8.289 0a.7.7 0 01-.7.7h-1.38a.7.7 0 010-1.4h1.38a.7.7 0 01.701.7zm-4.149 0a.7.7 0 01-.7.7H8.293a.7.7 0 010-1.4h1.38a.7.7 0 01.702.7z","fill":"#bac1cc"}})])
          )
        }
      }
    